import Header from './Header';
import Footer from './Footer';
import { useState, useEffect } from 'react';

const Layout = ({ children }) => {
 const [showButton, setShowButton] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    setShowButton(window.scrollY > 300);
  };
  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">{children}</main>
        <Footer />
      </div>
      {showButton && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 bg-[#ff7a00] text-white p-3 rounded-full shadow-lg hover:bg-[#e06a00] transition z-50"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default Layout;